export const css = {
	root: '_7QzPJV5h',
	heading: '_3eV4H7Ri',
	required: '_36q0SuuF',
	prologue: '_3uOKaS3c',
	formbody: '_3mHgv6TR',
	epilogue: '_2xfvYb9y',
	formLabel: '_1EZV0zal',
	formLikert: '_1sktraMn',
	formSelection: 'pOmGS7Xe',
	formRadioFieldset: 'BDQJvZn6',
	formString: 'kp4DHP_w',
	formText: '_1z7uzelB',
	' _key': 'lcc-rcs/form'
};

export default css;
